import React, { useContext } from "react";
import "./MRadioPlayerMain.css";
import MSlidingPlayer from "./MSlidingPlayer";
import { AudioContext } from "../../services/AudioContext";


export default function MRadioPlayerMain() {

  const audioContext = useContext(AudioContext);
  const audioRef = audioContext?.audioRef ?? null;

  return (
    <div className="m-radio-player-header">
      <MSlidingPlayer />
    </div>
  );
}
